//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fundsRecordsDetailApi } from '../api';
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      form: {}
    };
  },
  methods: {
    open: function open(id) {
      var _this = this;
      fundsRecordsDetailApi(id).then(function (res) {
        _this.form = res;
        _this.form.extra = _this.form.extra.split(',');
      });
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.form = {};
      this.dialogFormVisible = false;
    }
  }
};